import React, { useEffect, useState } from 'react';
import useSetState from '../../../../hooks/useSetState';
import { useDispatch, useSelector } from 'react-redux';
import ChargingRseeReportTabFilter from '../filters/chargingRseeReportTabFilter';
import Table from '../../../../components/table';
import { chargingRseeReportListColumns } from '../../../../enums/columns/chargingRseeReportList';
import { getRechargeChairsReportRequest } from '../../../../redux/financialTransactions/actions';
import submitForm from '../../../../utils/submitForm';

const ChargingRseeReportTab = () => {
  let dispatch = useDispatch();

  const [totalRecords, setTotalRecords] = useState(0);
  const [controls, setControls] = useSetState({
    filter: '',
    sort: { sortType: 'desc', sortBy: 'date', sortQuery: '', filterQuery: '' },
    query: '',
    pageNumber: 1,
    pageSize: 10,
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const {
    rechargeChairsReportList,
    getRechargeChairsReportLoading,
    rechargeChairsReportListTotalRecords,
  } = useSelector(state => ({
    rechargeChairsReportList:
      state.financialTransactionsReducer.rechargeChairsReportList,
    getRechargeChairsReportLoading:
      state.financialTransactionsReducer.getRechargeChairsReportLoading,
    rechargeChairsReportListTotalRecords:
      state.financialTransactionsReducer.rechargeChairsReportListTotalRecords,
  }));

  const getRechargeChairsReport = (pageNumber, pageSize) => {
    const query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
    dispatch(getRechargeChairsReportRequest(query))
      .then(result => {
        setTotalRecords(result.payload.totalRecords);
        onChangeValue('pageNumber', result.payload.pageNumber);
        onChangeValue('pageSize', result.payload.pageSize);
      })
      .catch(error => console.log('error', error));
  };

  const buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&sort=${controls.sort.sortQuery || 'date-desc'}`;
      if (controls.sort.filterQuery) {
        query += '&' + controls.sort.filterQuery;
      }
      return query;
    }
  };

  const sortTable = columnName => {
    const sortType = controls.sort.sortType === 'asc' ? 'desc' : 'asc';
    onChangeValue('sort', { ...controls.sort, sortType, sortBy: columnName });
  };

  const filterAndSort = () => {
    let searchQuery = buildSearchQuery(1, controls.pageSize);
    dispatch(getRechargeChairsReportRequest(searchQuery));
  };

  const applyFilters = (event, fromDate, toDate) => {
    event.preventDefault();
    const queryString = submitForm(event, fromDate, toDate);
    onChangeValue('sort', { ...controls.sort, filterQuery: queryString });
  };

  const resetForm = () => {
    onChangeValue('pageNumber', 1);
    onChangeValue('sort', { ...controls.sort, filterQuery: '' });
  };

  const onPageChanged = pageNumber => {
    onChangeValue('pageNumber', pageNumber);
    let query = `pageNumber=${pageNumber}&pageSize=${controls.pageSize}`;
    dispatch(getRseePackagesSalesReportRequest(query));
  };

  useEffect(() => {
    sortTable(controls.sort.sortBy);
  }, []);

  useEffect(() => {
    const sortQuery = `${controls.sort.sortBy}-${controls.sort.sortType}`;
    onChangeValue('sort', { ...controls.sort, sortQuery });
  }, [controls.sort.sortType]);

  useEffect(() => {
    if (controls.sort.sortQuery !== '') {
      onChangeValue('pageNumber', 1);
      filterAndSort();
    }
  }, [controls.sort.sortQuery]);

  useEffect(() => {
    if (controls.sort.filterQuery !== '') {
      onChangeValue('pageNumber', 1);
      filterAndSort();
    }
  }, [controls.sort.filterQuery]);

  return (
    <section>
      <ChargingRseeReportTabFilter
        pageNumber={controls.pageNumber}
        pageSize={controls.pageSize}
        applyFilters={applyFilters}
        getRechargeChairsReport={getRechargeChairsReport}
        resetForm={resetForm}
      />

      <div className='bg-white p-2'>
        <div className='panel-heading'>
          <i className='fas fa-list-alt px-1' />
          {locales('rsee.charging.report')}
        </div>
        <div className='table-responsive-lg'>
          <Table
            columns={chargingRseeReportListColumns}
            dataSource={rechargeChairsReportList}
            loading={getRechargeChairsReportLoading}
            sort={{ type: controls.sortType }}
            pagination={{
              currentPage: controls.pageNumber,
              pageSize: controls.pageSize,
              totalCount: rechargeChairsReportListTotalRecords,
              onPageChange: onPageChanged,
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default ChargingRseeReportTab;
